import * as defaults from "./defaults"

export * from "gdpr-guard"
export * from "./types"
export * from "./LocalStorageSavior"

export {
	defaults,
}
